module.exports = __webpack_public_path__ + "img/XXLlogo.3e35f7f5.png";